var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02507 4.68297H5.97141C5.67873 4.68297 5.38604 4.50736 5.21043 4.27321L3.57141 1.6976C3.22019 1.11224 3.62994 0.292725 4.33238 0.292725H8.60555C9.30799 0.292725 9.71775 1.0537 9.36653 1.6976L7.72751 4.27321C7.61043 4.50736 7.31775 4.68297 7.02507 4.68297Z",
    fill: "#ABD0FF",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5369 17.5025H2.40029C1.22955 17.5025 0.292969 16.5659 0.292969 15.3952V9.48297C0.292969 6.43906 2.75151 4.03906 5.73687 4.03906H7.20029C10.2442 4.03906 12.6442 6.4976 12.6442 9.48297V15.3952C12.6442 16.5659 11.7076 17.5025 10.5369 17.5025Z",
    fill: "white",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 12.5269L5.15183 12C5.44451 12.3512 5.73719 12.5854 6.14695 12.7025V11.3561C5.67866 11.2976 5.32744 11.122 5.09329 10.8878C4.85915 10.6537 4.74207 10.361 4.74207 9.95125C4.74207 9.60003 4.85915 9.30734 5.15183 9.0732C5.44451 8.83905 5.73719 8.72198 6.14695 8.66344V7.90247H6.79085V8.66344C7.31768 8.72198 7.72744 8.95612 8.13719 9.36588L7.61037 9.95125C7.37622 9.65856 7.08354 9.48295 6.84939 9.42442V10.7122C7.37622 10.7708 7.72744 10.9464 7.96159 11.1805C8.19573 11.4147 8.3128 11.7659 8.3128 12.1756C8.3128 12.5269 8.19573 12.8195 7.90305 13.0537C7.61037 13.2878 7.25915 13.4634 6.79085 13.4634V14.1659H6.14695V13.4634C5.50305 13.2878 5.03476 12.9951 4.625 12.5269ZM5.50305 9.83417C5.50305 10.1269 5.67866 10.361 6.08841 10.4195V9.24881C5.9128 9.24881 5.7372 9.36588 5.62012 9.48295C5.56159 9.60003 5.50305 9.7171 5.50305 9.83417ZM6.79085 12.6439C7.025 12.6439 7.20061 12.5269 7.31768 12.4098C7.43476 12.2927 7.49329 12.1756 7.49329 12C7.49329 11.6488 7.25915 11.4147 6.79085 11.3561V12.6439Z",
    fill: "#0069FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 13.9902V16.1561C11.415 16.9171 12.0004 17.5024 12.7614 17.5024H17.4443C18.2053 17.5024 18.7906 16.9171 18.7906 16.1561V13.9902",
    fill: "#ABD0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 13.9902V16.1561C11.415 16.9171 12.0004 17.5024 12.7614 17.5024H17.4443C18.2053 17.5024 18.7906 16.9171 18.7906 16.1561V13.9902",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 11.9414V14.1073C11.415 14.8682 12.0004 15.4536 12.7614 15.4536H17.4443C18.2053 15.4536 18.7906 14.8682 18.7906 14.1073V11.9414",
    fill: "#ABD0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 11.9414V14.1073C11.415 14.8682 12.0004 15.4536 12.7614 15.4536H17.4443C18.2053 15.4536 18.7906 14.8682 18.7906 14.1073V11.9414",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 9.89258V12.0584C11.415 12.8194 12.0004 13.4048 12.7614 13.4048H17.4443C18.2053 13.4048 18.7906 12.8194 18.7906 12.0584V9.89258",
    fill: "#ABD0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 9.89258V12.0584C11.415 12.8194 12.0004 13.4048 12.7614 13.4048H17.4443C18.2053 13.4048 18.7906 12.8194 18.7906 12.0584V9.89258",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5028 11.4146H12.5857C11.8833 11.4146 11.3564 10.8878 11.3564 10.1853V9.95119C11.3564 9.24875 11.8833 8.72192 12.5857 8.72192H17.5028C18.2052 8.72192 18.7321 9.24875 18.7321 9.95119V10.1853C18.7321 10.8292 18.2052 11.4146 17.5028 11.4146Z",
    fill: "white",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 13.9904V16.1562C16.332 16.9172 16.9174 17.5025 17.6784 17.5025H22.3613C23.1223 17.5025 23.7076 16.9172 23.7076 16.1562V13.9904",
    fill: "#ABD0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 13.9904V16.1562C16.332 16.9172 16.9174 17.5025 17.6784 17.5025H22.3613C23.1223 17.5025 23.7076 16.9172 23.7076 16.1562V13.9904",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 11.9415V14.1074C16.332 14.8684 16.9174 15.4537 17.6784 15.4537H22.3613C23.1223 15.4537 23.7076 14.8684 23.7076 14.1074V11.9415",
    fill: "#ABD0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 11.9415V14.1074C16.332 14.8684 16.9174 15.4537 17.6784 15.4537H22.3613C23.1223 15.4537 23.7076 14.8684 23.7076 14.1074V11.9415",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4784 13.405H17.5613C16.8589 13.405 16.332 12.8781 16.332 12.1757V11.9415C16.332 11.2391 16.8589 10.7123 17.5613 10.7123H22.4784C23.1808 10.7123 23.7076 11.2391 23.7076 11.9415V12.1757C23.7076 12.8781 23.1808 13.405 22.4784 13.405Z",
    fill: "white",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9521 5.26831V8.19514",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4883 6.73169H23.4151",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5127 1.17078V4.09761",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0488 2.63416H16.9757",
    stroke: "#0069FF",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCredit);
export default __webpack_public_path__ + "static/media/logo-credit.169fa2d5fad41c56e12b39f4528a5a2d.svg";
export { ForwardRef as ReactComponent };